<template>
    <Modal v-show="visible" v-on:close="closeModal" v-on:confirm="confirmModal"
           :confirmText="'Ændre Ban'" :title="'Ændre Straf'">
        <template v-slot:body>
            <div class="input-group">
                <label for="reason">Begrundelse</label>
                <input v-model="reason" type="text" id="reason">
            </div>
            <div class="input-group">
                <label for="date">Udløber</label>
                <div class="input-row">
                    <input v-model="date" type="date" id="date" :disabled="permanent">
                    <input v-model="time" type="time" id="time" :disabled="permanent">
                </div>
            </div>
            <div class="input-group checkbox">
                <input v-model="permanent" type="checkbox" id="permanent">
                <label for="permanent">Permanent</label>
            </div>
        </template>
    </Modal>
</template>

<script>
    import Modal from './Modal'

    export default {
        components: {
            Modal
        },
        data() {
            return {
                punishmentEdited: {
                    reason: null,
                    expire: {
                        date: null,
                        time: null
                    },
                    permanent: null
                },
            }
        },
        methods: {

            closeModal() {
                this.$emit('close');
                this.punishmentEdited = {
                    reason: null,
                    expire: {
                        date: null,
                        time: null
                    },
                    permanent: null
                };

            },
            confirmModal() {
                this.$emit('confirm', this.punishmentEdited);
                this.punishmentEdited = {
                    reason: null,
                    expire: {
                        date: null,
                        time: null
                    },
                    permanent: null
                };
            }
        },
        props: ['visible', 'punishment'],
        computed: {
            reason: {
                get: function () {
                    if (this.punishmentEdited.reason !== null) {
                        return this.punishmentEdited.reason;
                    }
                    return this.punishment.reason;
                },
                set: function (val) {
                    this.punishmentEdited.reason = val;
                }
            },
            permanent: {
                get: function () {
                    if (this.punishmentEdited.permanent !== null) {
                        return this.punishmentEdited.permanent;
                    }
                    return this.punishment.permanent;
                },
                set: function (val) {
                    this.punishmentEdited.permanent = val;
                }
            },
            date: {
                get: function () {
                    if (this.punishmentEdited.expire.date !== null) {
                        return this.punishmentEdited.expire.date;
                    }
                    return this.punishment.expire.date;
                },
                set: function (val) {
                    this.punishmentEdited.expire.date = val;
                }
            },
            time: {
                get: function () {
                    if (this.punishmentEdited.expire.time !== null) {
                        return this.punishmentEdited.expire.time;
                    }
                    return this.punishment.expire.time;
                },
                set: function (val) {
                    this.punishmentEdited.expire.time = val;
                }
            },
        },
    }
</script>

<style scoped lang="scss">
</style>